export enum FeedbackModalTypeValue {
    TimeReporting = 'TimeReporting',
    Cv = 'Cv',
    Gdpr = 'Gdpr',
    Other = 'Other'
}

export interface IFeedbackModalType {
    name: string;
    value: FeedbackModalTypeValue;
}

export interface IFeedbackModalAdditionalData {
    CurrentUrl: string;
    UserAgent: string;
    AppVersion: string;
    UserOS: string;
    UserLanguage: string;
}

export const FEEDBACK_MODAL_CATEGORIES: IFeedbackModalType[] = [
    { name: 'Time Reporting', value: FeedbackModalTypeValue.TimeReporting },
    { name: 'CV', value: FeedbackModalTypeValue.Cv },
    { name: 'GDPR', value: FeedbackModalTypeValue.Gdpr },
    { name: 'Other', value: FeedbackModalTypeValue.Other }
];

